import {
    SET_AVAILABLE_MEL,
    SET_MY_MEL,
    SET_PAST_MEL,
    SET_CART_MEL,
    ADD_DETAILS_MEL
} from './types'

export default function(state={}, action) {
    switch (action.type) {
        /*case ALL_INVENTORY: {
            const {available, my} = action.payload.reduce(({available,my},stone) => {
                if (stone.customerId==null) return {available: available.concat([stone]), my};
                else return {available, my: my.concat([stone])};
            }, {available: [], my: []});
            return {...state, available, my}
        }*/
        case SET_AVAILABLE_MEL: {
            return {...state, available: action.payload}
        }
        case SET_MY_MEL: {
            return {...state, my: action.payload}
        }
        case SET_PAST_MEL: {
            return {...state, past: action.payload}
        }
        case ADD_DETAILS_MEL: {
            if (!action.payload || !action.payload.parcelName) return state;
            return {...state, details: {...state.details, [action.payload.parcelName]: action.payload}}
        }
        default: {
            return state;
        }
    }
}